import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);
const em = (chunks: React.ReactNode) => (
    <em>
        {chunks}
    </em>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <>
                    <p>
                        <FormattedMessage defaultMessage="Use the filter bar to narrow results by <strong>test name</strong>, <strong>category</strong>,<strong>product</strong>,<strong>mode</strong>, or <strong>status</strong>." id="use_the_filter_bar_to_narrow_results_by.576d35d8" values={{ strong }} />
                    </p>
                    <p>
                        <FormattedMessage defaultMessage="Press <strong>Enter</strong> or click <em>Search</em> to execute. Clear individual filters to broaden your results." id="press_enter_or_click_search_to_execute_c.5615850b" values={{ em, strong }} />
                    </p>
                </>
            ),
            title: <FormattedMessage defaultMessage="Searching Tests" id="searching_tests.a3f3af8a" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click <strong>Create Test</strong> to open the wizard. You can select a product, pick questions, configure scoring, and assign the test to groups — all in one flow." id="click_create_test_to_open_the_wizard_you.f3f1caf9" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Creating a Test" id="creating_a_test.b332a7c5" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the action menu on any row to <strong>clone</strong>, <strong>delete</strong>, or <strong>assign</strong> a test. Cloning creates an independent copy you can modify without affecting the original." id="use_the_action_menu_on_any_row_to_clone.74c08bcc" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Managing Tests" id="managing_tests.59e524f8" />
        }
    ],
    title: <FormattedMessage defaultMessage="Custom Tests" id="custom_tests.9e7494ea" />
};
